// このファイルは pnpm sync:vendor で生成されます。
export const CHART_JS_PATH = '/vendor/chart-ecc3cd1e.js';
export const CHART_DATALABELS_PATH = '/vendor/chartjs-plugin-datalabels-20c08f3d.js';
export const HTML_TO_IMAGE_PATH = '/vendor/html-to-image-a90b4290.js';
export const VENDOR_PATHS = [CHART_JS_PATH, CHART_DATALABELS_PATH, HTML_TO_IMAGE_PATH] as const;
